var cov_15bswh9rcg = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/Dragger.tsx",
      hash = "c077038150b46166ed58258264acbcaad041ad14",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/Dragger.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 16
        }
      },
      "1": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 48
        }
      },
      "2": {
        start: {
          line: 16,
          column: 23
        },
        end: {
          line: 16,
          column: 33
        }
      },
      "3": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 93
        }
      },
      "4": {
        start: {
          line: 17,
          column: 68
        },
        end: {
          line: 17,
          column: 92
        }
      },
      "5": {
        start: {
          line: 21,
          column: 24
        },
        end: {
          line: 21,
          column: 34
        }
      },
      "6": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 41
        }
      },
      "7": {
        start: {
          line: 26,
          column: 60
        },
        end: {
          line: 26,
          column: 70
        }
      },
      "8": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 38,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 29
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 17,
            column: 52
          },
          end: {
            line: 17,
            column: 53
          }
        },
        loc: {
          start: {
            line: 17,
            column: 68
          },
          end: {
            line: 17,
            column: 92
          }
        },
        line: 17
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 28
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 11
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 25
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 15,
            column: 25
          },
          end: {
            line: 15,
            column: 27
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 18
          },
          end: {
            line: 32,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 18
          },
          end: {
            line: 32,
            column: 26
          }
        }, {
          start: {
            line: 32,
            column: 30
          },
          end: {
            line: 32,
            column: 39
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 36,
            column: 52
          },
          end: {
            line: 36,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 52
          },
          end: {
            line: 36,
            column: 60
          }
        }, {
          start: {
            line: 36,
            column: 64
          },
          end: {
            line: 36,
            column: 74
          }
        }],
        line: 36
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/Dragger.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

// obsolete code
import React from 'react';
import { PureComponent } from '../component';
import { uploadClass } from './styles';
import Drop from './Drop';
import { accept as attrAccept } from '../utils';

var Dragger =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Dragger, _PureComponent);

  var _super = _createSuper2(Dragger);

  function Dragger(props) {
    var _this;

    _classCallCheck(this, Dragger);

    cov_15bswh9rcg.f[0]++;
    cov_15bswh9rcg.s[0]++;
    _this = _super.call(this, props);
    cov_15bswh9rcg.s[1]++;
    _this.handleDrop = _this.handleDrop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Dragger, [{
    key: "getMatchedFile",
    value: function getMatchedFile() {
      var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_15bswh9rcg.b[0][0]++, []);
      cov_15bswh9rcg.f[1]++;

      var _ref = (cov_15bswh9rcg.s[2]++, this.props),
          accept = _ref.accept;

      cov_15bswh9rcg.s[3]++;
      return Array.prototype.slice.call(files).filter(function (file) {
        cov_15bswh9rcg.f[2]++;
        cov_15bswh9rcg.s[4]++;
        return attrAccept(file, accept);
      });
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(files) {
      cov_15bswh9rcg.f[3]++;

      var _ref2 = (cov_15bswh9rcg.s[5]++, this.props),
          addFile = _ref2.addFile;

      cov_15bswh9rcg.s[6]++;
      addFile({
        files: files,
        fromDragger: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_15bswh9rcg.f[4]++;

      var _ref3 = (cov_15bswh9rcg.s[7]++, this.props),
          children = _ref3.children,
          disabled = _ref3.disabled,
          multiple = _ref3.multiple,
          limit = _ref3.limit,
          accept = _ref3.accept;

      cov_15bswh9rcg.s[8]++;
      return (
        /*#__PURE__*/
        React.createElement(Drop, {
          className: uploadClass('dragger-wrapper'),
          drop: true,
          disabled: disabled,
          multiple: (cov_15bswh9rcg.b[1][0]++, multiple) || (cov_15bswh9rcg.b[1][1]++, limit > 1),
          accept: accept,
          onDrop: this.handleDrop,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('dragger-area', (cov_15bswh9rcg.b[2][0]++, disabled) && (cov_15bswh9rcg.b[2][1]++, 'disabled')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 36,
            columnNumber: 9
          }
        }, children))
      );
    }
  }]);

  return Dragger;
}(PureComponent);

export default Dragger;